'use strict';

import recommendations from './product/recommendations';

export default {
    init: function () {

    recommendations.init();
    $('#homepage-hero').slick({
    	arrows: true,
    	autoplay: true,
    	autoplaySpeed: 4000,
    	dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                	  arrows: false
                }
            }
        ]
    });
    $('body').on('click', '.shop-now-quickview a', function (e) {
        e.preventDefault();
        quickview.show({
            url: e.target.href,
            source: 'quickview',
            callback: function() {
            	images();
                variant();
                renderThumbnails();
            }
        });
    })
    $('.sub-feature-article').slick({
    	arrows: false,
    	dots: false,
    	infinite: false,
    	slidesToShow: 3,
    	slidesToScroll: 3,
    	responsive: [
	         {
	       	  breakpoint: 480,
	             settings: {
	            	slidesToShow: 1,
	     	        slidesToScroll: 1,
	     	        infinite: true,
	     	        arrows: false,
	     	        dots: true
	             }
	         }
        ]
    });
    
    }
};
